import React from "react";

function Privacy() {
  return (
    <main className="page">
      <article className="panel terms-doc">
        <h1>Privacy Policy</h1>
        <p className="terms-doc__effective">
          <strong>Effective Date:</strong> 22 April 2026
        </p>

        <p>
          WillPlay (“Platform”, “we”, “our”, “us”) is committed to protecting your privacy. This Privacy Policy explains
          how we collect, use, store, and protect your information when you use WillPlay.
        </p>
        <p>By using the Platform, you agree to this Privacy Policy.</p>

        <section className="terms-doc__section">
          <h2>1. Platform Nature</h2>
          <p>
            WillPlay is a technology platform that enables users to discover, create, host, and join sports matches and
            tournaments. WillPlay does not organize or control events and does not act as a participant in user interactions.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>2. Information We Collect</h2>
          <p>We may collect the following information:</p>

          <h3>a. Personal Information</h3>
          <ul className="terms-list">
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number (if provided)</li>
            <li>Account login credentials</li>
          </ul>

          <h3>b. Usage Information</h3>
          <ul className="terms-list">
            <li>Pages visited</li>
            <li>Features used (matches, tournaments, chat)</li>
            <li>Device type, browser, IP address</li>
          </ul>

          <h3>c. Location Information</h3>
          <ul className="terms-list">
            <li>Location entered while creating matches</li>
            <li>Latitude and longitude (for maps and match discovery)</li>
          </ul>

          <h3>d. Communication Data</h3>
          <ul className="terms-list">
            <li>Messages sent through in-app chat</li>
            <li>Notifications and interactions</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className="terms-list">
            <li>Create and manage your account</li>
            <li>Enable match and tournament creation/joining</li>
            <li>Display nearby matches using location data</li>
            <li>Facilitate communication between users</li>
            <li>Improve platform performance and user experience</li>
            <li>Send important updates, alerts, and notifications</li>
            <li>Respond to support requests</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>4. No Payment Data</h2>
          <ul className="terms-list">
            <li>WillPlay does not collect or process any payment information</li>
            <li>Any financial transactions occur outside the platform between users</li>
            <li>We do not store or access banking or payment details</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>5. Sharing of Information</h2>
          <p>We do not sell or rent your personal data.</p>
          <p>We may share limited information:</p>
          <ul className="terms-list">
            <li>With other users (only necessary details like name or contact for match coordination)</li>
            <li>When required by law or legal authorities</li>
            <li>To protect the safety, rights, and integrity of users and the platform</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>6. User Responsibility</h2>
          <ul className="terms-list">
            <li>You are responsible for protecting your login credentials</li>
            <li>You should avoid sharing sensitive personal information in chat</li>
            <li>Any interaction with other users is at your own discretion</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>7. Location &amp; Map Data</h2>
          <ul className="terms-list">
            <li>Location information is used to improve match discovery</li>
            <li>Map services (e.g., Google Maps) may process location data</li>
            <li>WillPlay does not guarantee accuracy of user-provided locations</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>8. Communication &amp; Chat</h2>
          <ul className="terms-list">
            <li>Messages sent through the platform may be stored</li>
            <li>This helps improve safety, moderation, and support</li>
            <li>WillPlay is not responsible for user-generated content</li>
            <li>Misuse of chat may lead to account action</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>9. Data Security</h2>
          <p>We implement reasonable security measures to protect your data, including:</p>
          <ul className="terms-list">
            <li>Controlled access</li>
            <li>Secure storage practices</li>
          </ul>
          <p>However, no system is completely secure, and we cannot guarantee absolute protection.</p>
        </section>

        <section className="terms-doc__section">
          <h2>10. Data Retention</h2>
          <ul className="terms-list">
            <li>We retain your data as long as your account is active</li>
            <li>Data may be retained for legal, security, or operational reasons</li>
            <li>You may request account deletion</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>11. Third-Party Services</h2>
          <p>WillPlay may use third-party services such as:</p>
          <ul className="terms-list">
            <li>Hosting providers</li>
            <li>Analytics tools</li>
            <li>Map services (Google Maps)</li>
          </ul>
          <p>
            These services may process limited user data. WillPlay is not responsible for their independent privacy
            practices.
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>12. Children’s Privacy</h2>
          <ul className="terms-list">
            <li>WillPlay is not intended for users under 13 years of age</li>
            <li>We do not knowingly collect data from children</li>
            <li>If such data is identified, it will be removed</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>13. Limitation of Responsibility</h2>
          <p>WillPlay is not responsible for:</p>
          <ul className="terms-list">
            <li>User interactions outside the platform</li>
            <li>Host cancellations or no-shows</li>
            <li>Disputes between users</li>
            <li>Misuse of shared information by other users</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>14. Changes to Privacy Policy</h2>
          <ul className="terms-list">
            <li>We may update this Privacy Policy at any time</li>
            <li>Updates will be posted on the platform</li>
            <li>Continued use means acceptance of changes</li>
          </ul>
        </section>

        <section className="terms-doc__section">
          <h2>15. Governing Law</h2>
          <p>This Privacy Policy is governed by the laws of India.</p>
        </section>

        <section className="terms-doc__section">
          <h2>16. Contact</h2>
          <p>
            For privacy-related questions:{" "}
            <a href="mailto:support@willplay.in">support@willplay.in</a>
          </p>
        </section>

        <section className="terms-doc__section">
          <h2>17. Consent</h2>
          <p>
            By using WillPlay, you acknowledge that you have read, understood, and agreed to this Privacy Policy.
          </p>
        </section>
      </article>
    </main>
  );
}

export default Privacy;
